import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, Calendar } from "lucide-react";
import Reveal from "../components/Reveal";
import { EVENTS, getUpcomingEvents } from "../mock/mock";

const Events = () => {
  const upcoming = getUpcomingEvents();
  return (
    <div className="overflow-hidden">
      <section className="pt-40 pb-16 px-5 text-center relative">
        <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[500px] h-[400px] bg-[#e0b04c]/8 rounded-full blur-[130px] pointer-events-none" />
        <Reveal className="relative z-10 max-w-3xl mx-auto">
          <p className="text-[#e0b04c] text-sm tracking-[0.3em] uppercase font-medium mb-5">See Us Live</p>
          <h1 className="font-serif-display text-5xl md:text-6xl text-[#f5f0e8] leading-tight">
            Upcoming <span className="text-gold-gradient">Events</span>
          </h1>
          <p className="text-[#b3a998] text-lg leading-relaxed mt-6 max-w-2xl mx-auto">
            Catch A.T.O.M. live. Feel the groove, sing along, and celebrate the
            timeless music of Frankie Beverly &amp; Maze.
          </p>
        </Reveal>
      </section>

      <section className="px-5 pb-20">
        <div className="max-w-4xl mx-auto space-y-4">
          {upcoming.map((e, i) => (
            <Reveal key={i} delay={i * 80}>
              <div className="group flex flex-col sm:flex-row items-stretch gap-6 p-6 rounded-xl bg-[#12100c] border border-white/5 hover:border-[#e0b04c]/35 hover:bg-[#161309] transition-all duration-400">
                {/* Date block */}
                <div className="flex sm:flex-col items-center justify-center gap-2 sm:gap-0 sm:w-24 py-3 rounded-lg bg-[#e0b04c]/10 group-hover:bg-[#e0b04c]/20 transition-colors flex-shrink-0">
                  <span className="font-serif-display text-4xl text-gold-gradient leading-none">{e.day}</span>
                  <span className="text-[#e0b04c] text-sm tracking-widest font-medium">{e.month}</span>
                  <span className="text-[#8f8577] text-xs">{e.year}</span>
                </div>
                {/* Info */}
                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="font-serif-display text-2xl text-[#f5f0e8] mb-2 group-hover:text-[#e0b04c] transition-colors">{e.venue}</h3>
                  <div className="flex items-start gap-2 text-[#9c917f] text-sm">
                    <MapPin size={16} className="text-[#e0b04c] mt-0.5 flex-shrink-0" />
                    <span>{e.address}{e.city && `, ${e.city}`}</span>
                  </div>
                  {e.note && <p className="text-[#e0b04c]/80 text-sm mt-2">{e.note}</p>}
                </div>
                {/* Action */}
                <div className="flex items-center">
                  <Link to="/booking" className="inline-flex items-center gap-1.5 text-[#e0b04c] font-medium text-sm border border-[#e0b04c]/30 px-5 py-2.5 rounded-md hover:bg-[#e0b04c] hover:text-[#0c0a08] transition-all duration-300">
                    Details <ArrowUpRight size={16} />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal className="text-center pt-8">
            <p className="text-[#8f8577] italic">More dates coming soon. Follow us for announcements!</p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 px-5 bg-[#0a0806]/60 border-t border-white/5">
        <Reveal className="max-w-2xl mx-auto text-center">
          <Calendar className="text-[#e0b04c] mx-auto mb-6" size={40} />
          <h2 className="font-serif-display text-4xl text-[#f5f0e8] mb-5">Want A.T.O.M. at Your Event?</h2>
          <p className="text-[#b3a998] mb-8">We perform throughout the United States for the right events. Reach out to check our availability.</p>
          <Link to="/booking" className="inline-flex bg-gradient-to-b from-[#e8bc55] to-[#c99339] text-[#0c0a08] font-semibold px-8 py-4 rounded-md hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(224,176,76,0.4)] transition-all duration-300">
            Request Availability
          </Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Events;
